import { useSnapshot } from 'valtio'
import { options } from '../../optionsStorage'
import { hideCurrentModal } from '../../globalState'
import { SettingsScreen, SettingsSection, ToggleRow } from './SettingsUi'

/** Toggles backed by `disabledUiParts` — the option stores what is hidden. */
const UI_PART_TOGGLES = [
  { part: 'scoreboard', label: 'ScoreBoard', description: 'Блок справа со счётом, статистикой или статусами' },
  { part: 'hotbar', label: 'HotBar', description: 'Здоровье, голод, броня, опыт, инвентарь' },
] as const

export const OverlayScreen = ({ canGoBack }: { canGoBack?: boolean }) => {
  const { disabledUiParts, displayBossBars } = useSnapshot(options)

  const setUiPart = (part: string, visible: boolean) => {
    options.disabledUiParts = visible
      ? disabledUiParts.filter(x => x !== part)
      : [...disabledUiParts, part]
  }

  return <SettingsScreen title='Оверлей' onBack={canGoBack ? hideCurrentModal : undefined}>
    <SettingsSection title='Игровой HUD'>
      {UI_PART_TOGGLES.map(({ part, label, description }) => (
        <ToggleRow
          key={part}
          label={label}
          description={description}
          checked={!disabledUiParts.includes(part)}
          onChange={visible => setUiPart(part, visible)}
        />
      ))}
      <ToggleRow
        label='BossBar'
        description='Появляется сверху по центру при появлении босса. Отображает его жизни'
        checked={displayBossBars}
        onChange={value => {
          options.displayBossBars = value
        }}
      />
    </SettingsSection>
  </SettingsScreen>
}
